<template>
    <div class="onHead">
      <p class="title">淘金商城管理系统 <i class="el-icon-s-fold"  @click="Collapse" style="margin-left:10px;cursor: pointer;"></i></p>
      <div class="login_centent">
        <img src="../assets/avtor.png" class="head_img">
        <el-popover
          style="margin-top:5px"
          placement="top-start"
          width="50"
          trigger="click">
          <div style="color:#3b79ca;font-weight: bold;cursor: pointer;" @click="deatilPassward">修改密码</div>
        <span class="login_cen_span" slot="reference">{{getInfo.userAccount}}</span>
        </el-popover>
        <div class="out_btn" @click="outMethod">退出</div>

        <el-dialog
          title="修改密码"
          :visible.sync="dialogVisible"
          width="500px"
          top="15%"
          style="padding:20px 10px 0 10px"
          :before-close="handleClose">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="ruleForm">
            <el-form-item label="原密码：" prop="name" placeholder="请输入密码">
              <el-input v-model="ruleForm.name" style="width:298px"></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="newName" placeholder="请输入密码">
              <el-input v-model="ruleForm.newName" style="width:298px"></el-input>
            </el-form-item>
            <el-form-item style="text-align:center;margin-top:20px;margin-right:75px">
              <el-button @click="handleClose">取消</el-button>
              <el-button type="primary" style="background-color:#FD4C5C;border-color:#FD4C5C;margin-left:65px" @click="submitForm('ruleForm')">确定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </div>
</template>

<script>
    export default {
      name: "onHead",
      data(){
        return{
          userInfo: '',
          NickName:'',
          dialogVisible:false,
          ruleForm:{
            name:'',
            newName:''
          },
          getInfo:{},
          isCollapse: false,
          rules:{
            name: [
              { required: true, message: '请输入密码', trigger: 'blur' },
            ],
          newName: [
              { required: true, message: '请输入密码', trigger: 'blur' },
              { min: 6,  message: '长度最少6个字符', trigger: 'blur' }
            ],
        },
        }
      },
      created(){
        this.getinfo()
      },
      methods: {
        outMethod(){
          var that=this;
          this.$confirm('确定要退出登录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() =>{
            localStorage.removeItem('userInfo');
            that.$router.push({
              path: '/login'
            })
          })
        },
        handleClose(){
          this.dialogVisible = false
        },
        deatilPassward(){
          this.dialogVisible = true
        },
        getinfo(){
            var info= localStorage.getItem('myInfo');
            if (info) {
              this.getInfo = JSON.parse(info)
            }
        },
        submitForm(formName) {
          let that = this
          that.$refs[formName].validate((valid) => {
            if (valid) {
              that.$http.axiosFun(that.$api.user.password,{
                newPassword: that.ruleForm.newName,
                password : that.ruleForm.name,
              },function (res) {
                if (res.code=='0'){
                  that.$message({
                    message: '修改成功',
                    type: 'success',
                    offset: '500',
                    center: true
                  });
                  that.dialogVisible = false;
                }else {
                  that.$message.error(res.msg);
                }
              })
            } else {
              return false;
            }
        });
      },
      Collapse() {
          this.isCollapse = !this.isCollapse;
          this.$emit("Collapse");
        },
      }
    }
</script>

<style lang="scss" scoped>
  .onHead{
    width: 100%;
    height: 80px;
    background: #294666;
    z-index: 99;
    // position: absolute;
    // top: 0;
    // left: 0;
    display: flex;
    justify-content: space-between;
    line-height: 80px;
    padding: 0 35px;
    box-sizing: border-box;
    .title{
      font-size: 24px;
      color: #fff;
    }
    .login_centent{
      display: flex;
      align-items: center;
      color: #ffffff;
      .head_img{
        width: 40px;
        height: 40px;
        border-radius: 20px;
        background: #ffff;
        margin-right: 12px;
        cursor: pointer;
      }
      .login_cen_span{
        cursor: pointer;
      }
      .out_btn{
        width: 96px;
        height: 40px;
        font-size: 16px;
        color: #FD4C5C;
        border-radius: 5px;
        border: 1px solid #FD4C5C;
        text-align: center;
        line-height: 40px;
        margin-left: 28px;
        cursor: pointer;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/onHead.vue